import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../appState';
import { childOfKey } from '../models/childKeys';
import { AngebotOffer, selectableChildKeys, toAngebotOffers } from '../models/angebotOffers';
import { findOrphanKeys } from './orphanedOffersSaga';
import { findStoreState } from './sharedDispatcher';

export interface TgvTakeOverOffer {
  key: string;
  app: App;
  angebotsId?: string;
  uebernommenKey: string;
  state: unknown;
}

const readChildStates = (keys: string[]): Record<string, unknown> =>
  Object.fromEntries(
    keys.map(key => {
      const { appId, angebotsId } = childOfKey(key);
      return [key, findStoreState(appId, angebotsId) ?? null];
    }),
  );

export const readAngebotOffers = ({
  tiergruppe,
  transientState,
}: Pick<IAppState, 'tiergruppe' | 'transientState'>): AngebotOffer[] =>
  toAngebotOffers({
    tiergruppe,
    transientState,
    children: readChildStates(selectableChildKeys(tiergruppe, transientState)),
  });

const toTakeOverOffer = (offer: AngebotOffer): TgvTakeOverOffer => {
  const { appId, angebotsId } = childOfKey(offer.key);
  return {
    key: offer.key,
    app: appId,
    angebotsId,
    uebernommenKey: offer.cardId ?? offer.key,
    state: offer.state,
  };
};

export const readTakeOverOffers = (state: IAppState): TgvTakeOverOffer[] => {
  const orphanKeys = findOrphanKeys(state);
  return readAngebotOffers(state)
    .filter(offer => !orphanKeys.includes(offer.key))
    .map(toTakeOverOffer);
};
